import { render, staticRenderFns } from "./UiForm.vue?vue&type=template&id=d62cb3b8"
import script from "./UiForm.vue?vue&type=script&lang=ts"
export * from "./UiForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports